export const followUpListTranslations = {
    en: {
        // Card Labels
        beneficiaryStatus: "Beneficiary Status",
        actionBy: "Action By",
        callStatus: "Call Status",
        remark: "Remark",
        nextFollowUp: "Next Follow-Up",

        // Values
        rugnaMitra: "RugnaMitra",
        noRemarkProvided: "No remark provided",
        notScheduled: "Not scheduled",
        at: "at",

        // Aria Labels
        followUpFor: "Follow-up for",
        on: "on",

        // Empty State
        noFollowUpsAvailable: "No Follow-Ups Available",
        noFollowUpsRecorded: "No follow-ups have been recorded for this beneficiary yet."
    },
    mr: {
        // Card Labels
        beneficiaryStatus: "लाभार्थी स्थिती",
        actionBy: "कृती कर्ता",
        callStatus: "कॉल स्थिती",
        remark: "टिप्पणी",
        nextFollowUp: "पुढील फॉलो-अप",

        // Values
        rugnaMitra: "रुग्णमित्र",
        noRemarkProvided: "टिप्पणी दिली नाही",
        notScheduled: "नियोजित नाही",
        at: "वाजता",

        // Aria Labels
        followUpFor: "यासाठी फॉलो-अप",
        on: "रोजी",

        // Empty State
        noFollowUpsAvailable: "फॉलो-अप उपलब्ध नाहीत",
        noFollowUpsRecorded: "या लाभार्थ्यासाठी अद्याप कोणतेही फॉलो-अप नोंदवले गेले नाहीत."
    }
};
